import React from 'react';
import { motion } from 'framer-motion';
interface AboutSectionProps {
  onNavigate: (page: string) => void;
}
export function AboutSection({
  onNavigate
}: AboutSectionProps) {
  return <section id="o-objektu" className="py-24 bg-white" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-15">
              O objektu
            </h2>
            <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-16">
              <p data-id="element-17">
                Nabízíme k dlouhodobému pronájmu komerční prostory, parkovací
                stání, haly a manipulační plochy v areálu ve městě Žlutice,
                okres Karlovy Vary. Celková plocha areálu činí 7 500 m², z toho
                3 000 m² vnitřních a 5 000 m² venkovních prostor.
              </p>
              <p data-id="element-18">
                Areál zahrnuje průmyslovou několikapatrovou železobetonovou a
                cihlovou budovu s možností bydlení či kancelářského využití,
                jednopatrové skladovací a výrobní haly a pomocně-technickou
                budovu. Součástí vybavení jsou portálové jeřáby, servisní jámy,
                kovářská výheň a truhlářská dílna.
              </p>
              <p className="font-medium text-slate-800" data-id="element-19">
                Areál je zabezpečen kamerovým systémem a hlídací službou. Celý
                areál je oplocený a uzavřený s elektrickými vraty. Na
                revitalizaci areálu se již pracuje. K nastěhování ihned.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative cursor-pointer group" onClick={() => onNavigate('gallery:17')} data-id="element-20">
            <div className="absolute inset-0 bg-[#e0a812] translate-x-4 translate-y-4 rounded-sm group-hover:translate-x-3 group-hover:translate-y-3 transition-transform duration-300" data-id="element-21" />
            <img src="https://cdn.magicpatterns.com/uploads/8NkEZSkRsEFQNTsoVNC4CE/20251009_183932.jpg" alt="Areál v podvečer" className="relative z-10 w-full h-auto object-cover rounded-sm shadow-xl group-hover:shadow-2xl transition-shadow duration-300" data-id="element-22" />
            <div className="absolute inset-0 z-20 bg-neutral-950/0 group-hover:bg-neutral-950/10 transition-colors duration-300 rounded-sm" data-id="element-23" />
          </motion.div>
        </div>
      </div>
    </section>;
}